export default {
  gender: [
    {
      "value": "0",
      "label": "好"
    }, {
      "value": "1",
      "label": "差"
    }
  ],
  "area": [
    {
      "id": "350212",
      "parentId": "350200",
      "areaName": "同安区",
      "mergerName": "中国,福建省,厦门市,同安区",
      "areaLevel": "3"
    },
    {
      "id": "350213",
      "parentId": "350200",
      "areaName": "翔安区",
      "mergerName": "中国,福建省,厦门市,翔安区",
      "areaLevel": "3"
    },
    {
      "id": "350300",
      "parentId": "350000",
      "areaName": "莆田市",
      "mergerName": "中国,福建省,莆田市",
      "areaLevel": "2"
    },
    {
      "id": "350302",
      "parentId": "350300",
      "areaName": "城厢区",
      "mergerName": "中国,福建省,莆田市,城厢区",
      "areaLevel": "3"
    },
    {
      "id": "350303",
      "parentId": "350300",
      "areaName": "涵江区",
      "mergerName": "中国,福建省,莆田市,涵江区",
      "areaLevel": "3"
    },
    {
      "id": "350304",
      "parentId": "350300",
      "areaName": "荔城区",
      "mergerName": "中国,福建省,莆田市,荔城区",
      "areaLevel": "3"
    },
    {
      "id": "350305",
      "parentId": "350300",
      "areaName": "秀屿区",
      "mergerName": "中国,福建省,莆田市,秀屿区",
      "areaLevel": "3"
    },
    {
      "id": "350322",
      "parentId": "350300",
      "areaName": "仙游县",
      "mergerName": "中国,福建省,莆田市,仙游县",
      "areaLevel": "3"
    },
    {
      "id": "350400",
      "parentId": "350000",
      "areaName": "三明市",
      "mergerName": "中国,福建省,三明市",
      "areaLevel": "2"
    },
    {
      "id": "350402",
      "parentId": "350400",
      "areaName": "梅列区",
      "mergerName": "中国,福建省,三明市,梅列区",
      "areaLevel": "3"
    },
    {
      "id": "350403",
      "parentId": "350400",
      "areaName": "三元区",
      "mergerName": "中国,福建省,三明市,三元区",
      "areaLevel": "3"
    },
    {
      "id": "350421",
      "parentId": "350400",
      "areaName": "明溪县",
      "mergerName": "中国,福建省,三明市,明溪县",
      "areaLevel": "3"
    },
    {
      "id": "350423",
      "parentId": "350400",
      "areaName": "清流县",
      "mergerName": "中国,福建省,三明市,清流县",
      "areaLevel": "3"
    },
    {
      "id": "350424",
      "parentId": "350400",
      "areaName": "宁化县",
      "mergerName": "中国,福建省,三明市,宁化县",
      "areaLevel": "3"
    },
    {
      "id": "350425",
      "parentId": "350400",
      "areaName": "大田县",
      "mergerName": "中国,福建省,三明市,大田县",
      "areaLevel": "3"
    },
    {
      "id": "350426",
      "parentId": "350400",
      "areaName": "尤溪县",
      "mergerName": "中国,福建省,三明市,尤溪县",
      "areaLevel": "3"
    },
    {
      "id": "350427",
      "parentId": "350400",
      "areaName": "沙县",
      "mergerName": "中国,福建省,三明市,沙县",
      "areaLevel": "3"
    },
    {
      "id": "350124",
      "parentId": "350100",
      "areaName": "闽清县",
      "mergerName": "中国,福建省,福州市,闽清县",
      "areaLevel": "3"
    },
    {
      "id": "350125",
      "parentId": "350100",
      "areaName": "永泰县",
      "mergerName": "中国,福建省,福州市,永泰县",
      "areaLevel": "3"
    },
    {
      "id": "350128",
      "parentId": "350100",
      "areaName": "平潭县",
      "mergerName": "中国,福建省,福州市,平潭县",
      "areaLevel": "3"
    },
    {
      "id": "350181",
      "parentId": "350100",
      "areaName": "福清市",
      "mergerName": "中国,福建省,福州市,福清市",
      "areaLevel": "3"
    },
    {
      "id": "350182",
      "parentId": "350100",
      "areaName": "长乐市",
      "mergerName": "中国,福建省,福州市,长乐市",
      "areaLevel": "3"
    },
    {
      "id": "350183",
      "parentId": "350100",
      "areaName": "福州新区",
      "mergerName": "中国,福建省,福州市,福州新区",
      "areaLevel": "3"
    },
    {
      "id": "110111",
      "parentId": "110100",
      "areaName": "房山区",
      "mergerName": "中国,北京,北京市,房山区",
      "areaLevel": "3"
    },
    {
      "id": "110000",
      "parentId": "0",
      "areaName": "北京",
      disabled: true,
      "mergerName": "中国,北京",
      "areaLevel": "1"
    },
    {
      "id": "110100",
      "parentId": "110000",
      "areaName": "北京市",
      "mergerName": "中国,北京,北京市",
      "areaLevel": "2"
    },
    {
      "id": "110101",
      "parentId": "110100",
      "areaName": "东城区",
      "mergerName": "中国,北京,北京市,东城区",
      "areaLevel": "3"
    },
    {
      "id": "110102",
      "parentId": "110100",
      "areaName": "西城区",
      "mergerName": "中国,北京,北京市,西城区",
      "areaLevel": "3"
    },
    {
      "id": "110105",
      "parentId": "110100",
      "areaName": "朝阳区",
      "mergerName": "中国,北京,北京市,朝阳区",
      "areaLevel": "3"
    },
    {
      "id": "110106",
      "parentId": "110100",
      "areaName": "丰台区",
      "mergerName": "中国,北京,北京市,丰台区",
      "areaLevel": "3"
    },
    {
      "id": "110107",
      "parentId": "110100",
      "areaName": "石景山区",
      "mergerName": "中国,北京,北京市,石景山区",
      "areaLevel": "3"
    },
    {
      "id": "110108",
      "parentId": "110100",
      "areaName": "海淀区",
      "mergerName": "中国,北京,北京市,海淀区",
      "areaLevel": "3"
    },
    {
      "id": "110109",
      "parentId": "110100",
      "areaName": "门头沟区",
      "mergerName": "中国,北京,北京市,门头沟区",
      "areaLevel": "3"
    },

    {
      "id": "110112",
      "parentId": "110100",
      "areaName": "通州区",
      "mergerName": "中国,北京,北京市,通州区",
      "areaLevel": "3"
    },
    {
      "id": "110113",
      "parentId": "110100",
      "areaName": "顺义区",
      "mergerName": "中国,北京,北京市,顺义区",
      "areaLevel": "3"
    },
    {
      "id": "110114",
      "parentId": "110100",
      "areaName": "昌平区",
      "mergerName": "中国,北京,北京市,昌平区",
      "areaLevel": "3"
    },
    {
      "id": "110115",
      "parentId": "110100",
      "areaName": "大兴区",
      "mergerName": "中国,北京,北京市,大兴区",
      "areaLevel": "3"
    },
    {
      "id": "110116",
      "parentId": "110100",
      "areaName": "怀柔区",
      "mergerName": "中国,北京,北京市,怀柔区",
      "areaLevel": "3"
    },
    {
      "id": "110117",
      "parentId": "110100",
      "areaName": "平谷区",
      "mergerName": "中国,北京,北京市,平谷区",
      "areaLevel": "3"
    },
    {
      "id": "110118",
      "parentId": "110100",
      "areaName": "密云区",
      "mergerName": "中国,北京,北京市,密云区",
      "areaLevel": "3"
    },
    {
      "id": "110119",
      "parentId": "110100",
      "areaName": "延庆区",
      "mergerName": "中国,北京,北京市,延庆区",
      "areaLevel": "3"
    },
    {
      "id": "110120",
      "parentId": "110100",
      "areaName": "中关村科技园区",
      "mergerName": "中国,北京,北京市,中关村科技园区",
      "areaLevel": "3"
    },
    {
      "id": "350000",
      "parentId": "0",
      "areaName": "福建省",
      "mergerName": "中国,福建省",
      "areaLevel": "1"
    },
    {
      "id": "350100",
      "parentId": "350000",
      "areaName": "福州市",
      "mergerName": "中国,福建省,福州市",
      "areaLevel": "2"
    },
    {
      "id": "350102",
      "parentId": "350100",
      "areaName": "鼓楼区",
      "mergerName": "中国,福建省,福州市,鼓楼区",
      "areaLevel": "3"
    },
    {
      "id": "350103",
      "parentId": "350100",
      "areaName": "台江区",
      "mergerName": "中国,福建省,福州市,台江区",
      "areaLevel": "3"
    },
    {
      "id": "350104",
      "parentId": "350100",
      "areaName": "仓山区",
      "mergerName": "中国,福建省,福州市,仓山区",
      "areaLevel": "3"
    },
    {
      "id": "350105",
      "parentId": "350100",
      "areaName": "马尾区",
      "mergerName": "中国,福建省,福州市,马尾区",
      "areaLevel": "3"
    },
    {
      "id": "350111",
      "parentId": "350100",
      "areaName": "晋安区",
      "mergerName": "中国,福建省,福州市,晋安区",
      "areaLevel": "3"
    },
    {
      "id": "350121",
      "parentId": "350100",
      "areaName": "闽侯县",
      "mergerName": "中国,福建省,福州市,闽侯县",
      "areaLevel": "3"
    },
    {
      "id": "350122",
      "parentId": "350100",
      "areaName": "连江县",
      "mergerName": "中国,福建省,福州市,连江县",
      "areaLevel": "3"
    },
    {
      "id": "350123",
      "parentId": "350100",
      "areaName": "罗源县",
      "mergerName": "中国,福建省,福州市,罗源县",
      "areaLevel": "3"
    },

    {
      "id": "350200",
      "parentId": "350000",
      "areaName": "厦门市",
      "mergerName": "中国,福建省,厦门市",
      "areaLevel": "2"
    },
    {
      "id": "350203",
      "parentId": "350200",
      "areaName": "思明区",
      "mergerName": "中国,福建省,厦门市,思明区",
      "areaLevel": "3"
    },
    {
      "id": "350205",
      "parentId": "350200",
      "areaName": "海沧区",
      "mergerName": "中国,福建省,厦门市,海沧区",
      "areaLevel": "3"
    },
    {
      "id": "350206",
      "parentId": "350200",
      "areaName": "湖里区",
      "mergerName": "中国,福建省,厦门市,湖里区",
      "areaLevel": "3"
    },
    {
      "id": "350211",
      "parentId": "350200",
      "areaName": "集美区",
      "mergerName": "中国,福建省,厦门市,集美区",
      "areaLevel": "3"
    },
    {
      "id": "350428",
      "parentId": "350400",
      "areaName": "将乐县",
      "mergerName": "中国,福建省,三明市,将乐县",
      "areaLevel": "3"
    },
    {
      "id": "350429",
      "parentId": "350400",
      "areaName": "泰宁县",
      "mergerName": "中国,福建省,三明市,泰宁县",
      "areaLevel": "3"
    },
    {
      "id": "350430",
      "parentId": "350400",
      "areaName": "建宁县",
      "mergerName": "中国,福建省,三明市,建宁县",
      "areaLevel": "3"
    },
    {
      "id": "350481",
      "parentId": "350400",
      "areaName": "永安市",
      "mergerName": "中国,福建省,三明市,永安市",
      "areaLevel": "3"
    },
    {
      "id": "350500",
      "parentId": "350000",
      "areaName": "泉州市",
      "mergerName": "中国,福建省,泉州市",
      "areaLevel": "2"
    },
    {
      "id": "350502",
      "parentId": "350500",
      "areaName": "鲤城区",
      "mergerName": "中国,福建省,泉州市,鲤城区",
      "areaLevel": "3"
    },
    {
      "id": "350503",
      "parentId": "350500",
      "areaName": "丰泽区",
      "mergerName": "中国,福建省,泉州市,丰泽区",
      "areaLevel": "3"
    },
    {
      "id": "350504",
      "parentId": "350500",
      "areaName": "洛江区",
      "mergerName": "中国,福建省,泉州市,洛江区",
      "areaLevel": "3"
    },
    {
      "id": "350505",
      "parentId": "350500",
      "areaName": "泉港区",
      "mergerName": "中国,福建省,泉州市,泉港区",
      "areaLevel": "3"
    },
    {
      "id": "350521",
      "parentId": "350500",
      "areaName": "惠安县",
      "mergerName": "中国,福建省,泉州市,惠安县",
      "areaLevel": "3"
    },
    {
      "id": "350524",
      "parentId": "350500",
      "areaName": "安溪县",
      "mergerName": "中国,福建省,泉州市,安溪县",
      "areaLevel": "3"
    },
    {
      "id": "350525",
      "parentId": "350500",
      "areaName": "永春县",
      "mergerName": "中国,福建省,泉州市,永春县",
      "areaLevel": "3"
    },
    {
      "id": "350526",
      "parentId": "350500",
      "areaName": "德化县",
      "mergerName": "中国,福建省,泉州市,德化县",
      "areaLevel": "3"
    },
    {
      "id": "350527",
      "parentId": "350500",
      "areaName": "金门县",
      "mergerName": "中国,福建省,泉州市,金门县",
      "areaLevel": "3"
    },
    {
      "id": "350581",
      "parentId": "350500",
      "areaName": "石狮市",
      "mergerName": "中国,福建省,泉州市,石狮市",
      "areaLevel": "3"
    },
    {
      "id": "350582",
      "parentId": "350500",
      "areaName": "晋江市",
      "mergerName": "中国,福建省,泉州市,晋江市",
      "areaLevel": "3"
    },
    {
      "id": "350583",
      "parentId": "350500",
      "areaName": "南安市",
      "mergerName": "中国,福建省,泉州市,南安市",
      "areaLevel": "3"
    },
    {
      "id": "350584",
      "parentId": "350500",
      "areaName": "台商投资区",
      "mergerName": "中国,福建省,泉州市,台商投资区",
      "areaLevel": "3"
    },
    {
      "id": "350585",
      "parentId": "350500",
      "areaName": "经济技术开发区",
      "mergerName": "中国,福建省,泉州市,经济技术开发区",
      "areaLevel": "3"
    },
    {
      "id": "350586",
      "parentId": "350500",
      "areaName": "高新技术开发区",
      "mergerName": "中国,福建省,泉州市,高新技术开发区",
      "areaLevel": "3"
    },
    {
      "id": "350587",
      "parentId": "350500",
      "areaName": "综合保税区",
      "mergerName": "中国,福建省,泉州市,综合保税区",
      "areaLevel": "3"
    },
    {
      "id": "350600",
      "parentId": "350000",
      "areaName": "漳州市",
      "mergerName": "中国,福建省,漳州市",
      "areaLevel": "2"
    },
    {
      "id": "350602",
      "parentId": "350600",
      "areaName": "芗城区",
      "mergerName": "中国,福建省,漳州市,芗城区",
      "areaLevel": "3"
    },
    {
      "id": "350603",
      "parentId": "350600",
      "areaName": "龙文区",
      "mergerName": "中国,福建省,漳州市,龙文区",
      "areaLevel": "3"
    },
    {
      "id": "350622",
      "parentId": "350600",
      "areaName": "云霄县",
      "mergerName": "中国,福建省,漳州市,云霄县",
      "areaLevel": "3"
    },
    {
      "id": "350623",
      "parentId": "350600",
      "areaName": "漳浦县",
      "mergerName": "中国,福建省,漳州市,漳浦县",
      "areaLevel": "3"
    },
    {
      "id": "350624",
      "parentId": "350600",
      "areaName": "诏安县",
      "mergerName": "中国,福建省,漳州市,诏安县",
      "areaLevel": "3"
    },
    {
      "id": "350625",
      "parentId": "350600",
      "areaName": "长泰县",
      "mergerName": "中国,福建省,漳州市,长泰县",
      "areaLevel": "3"
    },
    {
      "id": "350626",
      "parentId": "350600",
      "areaName": "东山县",
      "mergerName": "中国,福建省,漳州市,东山县",
      "areaLevel": "3"
    },
    {
      "id": "350627",
      "parentId": "350600",
      "areaName": "南靖县",
      "mergerName": "中国,福建省,漳州市,南靖县",
      "areaLevel": "3"
    },
    {
      "id": "350628",
      "parentId": "350600",
      "areaName": "平和县",
      "mergerName": "中国,福建省,漳州市,平和县",
      "areaLevel": "3"
    },
    {
      "id": "350629",
      "parentId": "350600",
      "areaName": "华安县",
      "mergerName": "中国,福建省,漳州市,华安县",
      "areaLevel": "3"
    },
    {
      "id": "350681",
      "parentId": "350600",
      "areaName": "龙海市",
      "mergerName": "中国,福建省,漳州市,龙海市",
      "areaLevel": "3"
    },
    {
      "id": "350700",
      "parentId": "350000",
      "areaName": "南平市",
      "mergerName": "中国,福建省,南平市",
      "areaLevel": "2"
    },
    {
      "id": "350702",
      "parentId": "350700",
      "areaName": "延平区",
      "mergerName": "中国,福建省,南平市,延平区",
      "areaLevel": "3"
    },
    {
      "id": "350703",
      "parentId": "350700",
      "areaName": "建阳区",
      "mergerName": "中国,福建省,南平市,建阳区",
      "areaLevel": "3"
    },
    {
      "id": "350721",
      "parentId": "350700",
      "areaName": "顺昌县",
      "mergerName": "中国,福建省,南平市,顺昌县",
      "areaLevel": "3"
    },
    {
      "id": "350722",
      "parentId": "350700",
      "areaName": "浦城县",
      "mergerName": "中国,福建省,南平市,浦城县",
      "areaLevel": "3"
    },
    {
      "id": "350723",
      "parentId": "350700",
      "areaName": "光泽县",
      "mergerName": "中国,福建省,南平市,光泽县",
      "areaLevel": "3"
    },
    {
      "id": "350724",
      "parentId": "350700",
      "areaName": "松溪县",
      "mergerName": "中国,福建省,南平市,松溪县",
      "areaLevel": "3"
    },
    {
      "id": "350725",
      "parentId": "350700",
      "areaName": "政和县",
      "mergerName": "中国,福建省,南平市,政和县",
      "areaLevel": "3"
    },
    {
      "id": "350781",
      "parentId": "350700",
      "areaName": "邵武市",
      "mergerName": "中国,福建省,南平市,邵武市",
      "areaLevel": "3"
    },
    {
      "id": "350782",
      "parentId": "350700",
      "areaName": "武夷山市",
      "mergerName": "中国,福建省,南平市,武夷山市",
      "areaLevel": "3"
    },
    {
      "id": "350783",
      "parentId": "350700",
      "areaName": "建瓯市",
      "mergerName": "中国,福建省,南平市,建瓯市",
      "areaLevel": "3"
    },
    {
      "id": "350800",
      "parentId": "350000",
      "areaName": "龙岩市",
      "mergerName": "中国,福建省,龙岩市",
      "areaLevel": "2"
    },
    {
      "id": "350802",
      "parentId": "350800",
      "areaName": "新罗区",
      "mergerName": "中国,福建省,龙岩市,新罗区",
      "areaLevel": "3"
    },
    {
      "id": "350803",
      "parentId": "350800",
      "areaName": "永定区",
      "mergerName": "中国,福建省,龙岩市,永定区",
      "areaLevel": "3"
    },
    {
      "id": "350821",
      "parentId": "350800",
      "areaName": "长汀县",
      "mergerName": "中国,福建省,龙岩市,长汀县",
      "areaLevel": "3"
    },
    {
      "id": "350823",
      "parentId": "350800",
      "areaName": "上杭县",
      "mergerName": "中国,福建省,龙岩市,上杭县",
      "areaLevel": "3"
    },
    {
      "id": "350824",
      "parentId": "350800",
      "areaName": "武平县",
      "mergerName": "中国,福建省,龙岩市,武平县",
      "areaLevel": "3"
    },
    {
      "id": "350825",
      "parentId": "350800",
      "areaName": "连城县",
      "mergerName": "中国,福建省,龙岩市,连城县",
      "areaLevel": "3"
    },
    {
      "id": "350881",
      "parentId": "350800",
      "areaName": "漳平市",
      "mergerName": "中国,福建省,龙岩市,漳平市",
      "areaLevel": "3"
    },
    {
      "id": "350900",
      "parentId": "350000",
      "areaName": "宁德市",
      "mergerName": "中国,福建省,宁德市",
      "areaLevel": "2"
    },
    {
      "id": "350902",
      "parentId": "350900",
      "areaName": "蕉城区",
      "mergerName": "中国,福建省,宁德市,蕉城区",
      "areaLevel": "3"
    },
    {
      "id": "350921",
      "parentId": "350900",
      "areaName": "霞浦县",
      "mergerName": "中国,福建省,宁德市,霞浦县",
      "areaLevel": "3"
    },
    {
      "id": "350922",
      "parentId": "350900",
      "areaName": "古田县",
      "mergerName": "中国,福建省,宁德市,古田县",
      "areaLevel": "3"
    },
    {
      "id": "350923",
      "parentId": "350900",
      "areaName": "屏南县",
      "mergerName": "中国,福建省,宁德市,屏南县",
      "areaLevel": "3"
    },
    {
      "id": "350924",
      "parentId": "350900",
      "areaName": "寿宁县",
      "mergerName": "中国,福建省,宁德市,寿宁县",
      "areaLevel": "3"
    },
    {
      "id": "350925",
      "parentId": "350900",
      "areaName": "周宁县",
      "mergerName": "中国,福建省,宁德市,周宁县",
      "areaLevel": "3"
    },
    {
      "id": "350926",
      "parentId": "350900",
      "areaName": "柘荣县",
      "mergerName": "中国,福建省,宁德市,柘荣县",
      "areaLevel": "3"
    },
    {
      "id": "350981",
      "parentId": "350900",
      "areaName": "福安市",
      "mergerName": "中国,福建省,宁德市,福安市",
      "areaLevel": "3"
    },
    {
      "id": "350982",
      "parentId": "350900",
      "areaName": "福鼎市",
      "mergerName": "中国,福建省,宁德市,福鼎市",
      "areaLevel": "3"
    },
    {
      "id": "350983",
      "parentId": "350900",
      "areaName": "东侨开发区",
      "mergerName": "中国,福建省,宁德市,东侨开发区",
      "areaLevel": "3"
    },
    {
      "id": "440000",
      "parentId": "0",
      "areaName": "广东省",
      "mergerName": "中国,广东省",
      "areaLevel": "1"
    },
    {
      "id": "440100",
      "parentId": "440000",
      "areaName": "广州市",
      "mergerName": "中国,广东省,广州市",
      "areaLevel": "2"
    },
    {
      "id": "440103",
      "parentId": "440100",
      "areaName": "荔湾区",
      "mergerName": "中国,广东省,广州市,荔湾区",
      "areaLevel": "3"
    },
    {
      "id": "440104",
      "parentId": "440100",
      "areaName": "越秀区",
      "mergerName": "中国,广东省,广州市,越秀区",
      "areaLevel": "3"
    },
    {
      "id": "440105",
      "parentId": "440100",
      "areaName": "海珠区",
      "mergerName": "中国,广东省,广州市,海珠区",
      "areaLevel": "3"
    },
    {
      "id": "440106",
      "parentId": "440100",
      "areaName": "天河区",
      "mergerName": "中国,广东省,广州市,天河区",
      "areaLevel": "3"
    },
    {
      "id": "440111",
      "parentId": "440100",
      "areaName": "白云区",
      "mergerName": "中国,广东省,广州市,白云区",
      "areaLevel": "3"
    },
    {
      "id": "440112",
      "parentId": "440100",
      "areaName": "黄埔区",
      "mergerName": "中国,广东省,广州市,黄埔区",
      "areaLevel": "3"
    },
    {
      "id": "440113",
      "parentId": "440100",
      "areaName": "番禺区",
      "mergerName": "中国,广东省,广州市,番禺区",
      "areaLevel": "3"
    },
    {
      "id": "440114",
      "parentId": "440100",
      "areaName": "花都区",
      "mergerName": "中国,广东省,广州市,花都区",
      "areaLevel": "3"
    },
    {
      "id": "440115",
      "parentId": "440100",
      "areaName": "南沙区",
      "mergerName": "中国,广东省,广州市,南沙区",
      "areaLevel": "3"
    },
    {
      "id": "440117",
      "parentId": "440100",
      "areaName": "从化区",
      "mergerName": "中国,广东省,广州市,从化区",
      "areaLevel": "3"
    },
    {
      "id": "440118",
      "parentId": "440100",
      "areaName": "增城区",
      "mergerName": "中国,广东省,广州市,增城区",
      "areaLevel": "3"
    },
    {
      "id": "440200",
      "parentId": "440000",
      "areaName": "韶关市",
      "mergerName": "中国,广东省,韶关市",
      "areaLevel": "2"
    },
    {
      "id": "440203",
      "parentId": "440200",
      "areaName": "武江区",
      "mergerName": "中国,广东省,韶关市,武江区",
      "areaLevel": "3"
    },
    {
      "id": "440204",
      "parentId": "440200",
      "areaName": "浈江区",
      "mergerName": "中国,广东省,韶关市,浈江区",
      "areaLevel": "3"
    },
    {
      "id": "440205",
      "parentId": "440200",
      "areaName": "曲江区",
      "mergerName": "中国,广东省,韶关市,曲江区",
      "areaLevel": "3"
    },
    {
      "id": "440222",
      "parentId": "440200",
      "areaName": "始兴县",
      "mergerName": "中国,广东省,韶关市,始兴县",
      "areaLevel": "3"
    },
    {
      "id": "440224",
      "parentId": "440200",
      "areaName": "仁化县",
      "mergerName": "中国,广东省,韶关市,仁化县",
      "areaLevel": "3"
    },
    {
      "id": "440229",
      "parentId": "440200",
      "areaName": "翁源县",
      "mergerName": "中国,广东省,韶关市,翁源县",
      "areaLevel": "3"
    },
    {
      "id": "440232",
      "parentId": "440200",
      "areaName": "乳源瑶族自治县",
      "mergerName": "中国,广东省,韶关市,乳源瑶族自治县",
      "areaLevel": "3"
    },
    {
      "id": "440233",
      "parentId": "440200",
      "areaName": "新丰县",
      "mergerName": "中国,广东省,韶关市,新丰县",
      "areaLevel": "3"
    },
    {
      "id": "440281",
      "parentId": "440200",
      "areaName": "乐昌市",
      "mergerName": "中国,广东省,韶关市,乐昌市",
      "areaLevel": "3"
    },
    {
      "id": "440282",
      "parentId": "440200",
      "areaName": "南雄市",
      "mergerName": "中国,广东省,韶关市,南雄市",
      "areaLevel": "3"
    },
    {
      "id": "440300",
      "parentId": "440000",
      "areaName": "深圳市",
      "mergerName": "中国,广东省,深圳市",
      "areaLevel": "2"
    },
    {
      "id": "440303",
      "parentId": "440300",
      "areaName": "罗湖区",
      "mergerName": "中国,广东省,深圳市,罗湖区",
      "areaLevel": "3"
    },
    {
      "id": "440304",
      "parentId": "440300",
      "areaName": "福田区",
      "mergerName": "中国,广东省,深圳市,福田区",
      "areaLevel": "3"
    },
    {
      "id": "440305",
      "parentId": "440300",
      "areaName": "南山区",
      "mergerName": "中国,广东省,深圳市,南山区",
      "areaLevel": "3"
    },
    {
      "id": "440306",
      "parentId": "440300",
      "areaName": "宝安区",
      "mergerName": "中国,广东省,深圳市,宝安区",
      "areaLevel": "3"
    },
    {
      "id": "440307",
      "parentId": "440300",
      "areaName": "龙岗区",
      "mergerName": "中国,广东省,深圳市,龙岗区",
      "areaLevel": "3"
    },
    {
      "id": "440308",
      "parentId": "440300",
      "areaName": "盐田区",
      "mergerName": "中国,广东省,深圳市,盐田区",
      "areaLevel": "3"
    },
    {
      "id": "440309",
      "parentId": "440300",
      "areaName": "龙华区",
      "mergerName": "中国,广东省,深圳市,龙华区",
      "areaLevel": "3"
    },
    {
      "id": "440310",
      "parentId": "440300",
      "areaName": "坪山区",
      "mergerName": "中国,广东省,深圳市,坪山区",
      "areaLevel": "3"
    },
    {
      "id": "440311",
      "parentId": "440300",
      "areaName": "光明新区",
      "mergerName": "中国,广东省,深圳市,光明新区",
      "areaLevel": "3"
    },
    {
      "id": "440312",
      "parentId": "440300",
      "areaName": "大鹏新区",
      "mergerName": "中国,广东省,深圳市,大鹏新区",
      "areaLevel": "3"
    },
    {
      "id": "440400",
      "parentId": "440000",
      "areaName": "珠海市",
      "mergerName": "中国,广东省,珠海市",
      "areaLevel": "2"
    },
    {
      "id": "440402",
      "parentId": "440400",
      "areaName": "香洲区",
      "mergerName": "中国,广东省,珠海市,香洲区",
      "areaLevel": "3"
    },
    {
      "id": "440403",
      "parentId": "440400",
      "areaName": "斗门区",
      "mergerName": "中国,广东省,珠海市,斗门区",
      "areaLevel": "3"
    },
    {
      "id": "440404",
      "parentId": "440400",
      "areaName": "金湾区",
      "mergerName": "中国,广东省,珠海市,金湾区",
      "areaLevel": "3"
    },
    {
      "id": "440405",
      "parentId": "440400",
      "areaName": "横琴新区",
      "mergerName": "中国,广东省,珠海市,横琴新区",
      "areaLevel": "3"
    },
    {
      "id": "440406",
      "parentId": "440400",
      "areaName": "经济开发区",
      "mergerName": "中国,广东省,珠海市,经济开发区",
      "areaLevel": "3"
    },
    {
      "id": "440500",
      "parentId": "440000",
      "areaName": "汕头市",
      "mergerName": "中国,广东省,汕头市",
      "areaLevel": "2"
    },
    {
      "id": "440507",
      "parentId": "440500",
      "areaName": "龙湖区",
      "mergerName": "中国,广东省,汕头市,龙湖区",
      "areaLevel": "3"
    },
    {
      "id": "440511",
      "parentId": "440500",
      "areaName": "金平区",
      "mergerName": "中国,广东省,汕头市,金平区",
      "areaLevel": "3"
    },
    {
      "id": "440512",
      "parentId": "440500",
      "areaName": "濠江区",
      "mergerName": "中国,广东省,汕头市,濠江区",
      "areaLevel": "3"
    },
    {
      "id": "440513",
      "parentId": "440500",
      "areaName": "潮阳区",
      "mergerName": "中国,广东省,汕头市,潮阳区",
      "areaLevel": "3"
    },
    {
      "id": "440514",
      "parentId": "440500",
      "areaName": "潮南区",
      "mergerName": "中国,广东省,汕头市,潮南区",
      "areaLevel": "3"
    },
    {
      "id": "440515",
      "parentId": "440500",
      "areaName": "澄海区",
      "mergerName": "中国,广东省,汕头市,澄海区",
      "areaLevel": "3"
    },
    {
      "id": "440523",
      "parentId": "440500",
      "areaName": "南澳县",
      "mergerName": "中国,广东省,汕头市,南澳县",
      "areaLevel": "3"
    },
    {
      "id": "440600",
      "parentId": "440000",
      "areaName": "佛山市",
      "mergerName": "中国,广东省,佛山市",
      "areaLevel": "2"
    },
    {
      "id": "440604",
      "parentId": "440600",
      "areaName": "禅城区",
      "mergerName": "中国,广东省,佛山市,禅城区",
      "areaLevel": "3"
    },
    {
      "id": "440605",
      "parentId": "440600",
      "areaName": "南海区",
      "mergerName": "中国,广东省,佛山市,南海区",
      "areaLevel": "3"
    },
    {
      "id": "440606",
      "parentId": "440600",
      "areaName": "顺德区",
      "mergerName": "中国,广东省,佛山市,顺德区",
      "areaLevel": "3"
    },
    {
      "id": "440607",
      "parentId": "440600",
      "areaName": "三水区",
      "mergerName": "中国,广东省,佛山市,三水区",
      "areaLevel": "3"
    },
    {
      "id": "440608",
      "parentId": "440600",
      "areaName": "高明区",
      "mergerName": "中国,广东省,佛山市,高明区",
      "areaLevel": "3"
    },
    {
      "id": "440700",
      "parentId": "440000",
      "areaName": "江门市",
      "mergerName": "中国,广东省,江门市",
      "areaLevel": "2"
    },
    {
      "id": "440703",
      "parentId": "440700",
      "areaName": "蓬江区",
      "mergerName": "中国,广东省,江门市,蓬江区",
      "areaLevel": "3"
    },
    {
      "id": "440704",
      "parentId": "440700",
      "areaName": "江海区",
      "mergerName": "中国,广东省,江门市,江海区",
      "areaLevel": "3"
    },
    {
      "id": "440705",
      "parentId": "440700",
      "areaName": "新会区",
      "mergerName": "中国,广东省,江门市,新会区",
      "areaLevel": "3"
    },
    {
      "id": "440781",
      "parentId": "440700",
      "areaName": "台山市",
      "mergerName": "中国,广东省,江门市,台山市",
      "areaLevel": "3"
    },
    {
      "id": "440783",
      "parentId": "440700",
      "areaName": "开平市",
      "mergerName": "中国,广东省,江门市,开平市",
      "areaLevel": "3"
    },
    {
      "id": "440784",
      "parentId": "440700",
      "areaName": "鹤山市",
      "mergerName": "中国,广东省,江门市,鹤山市",
      "areaLevel": "3"
    },
    {
      "id": "440785",
      "parentId": "440700",
      "areaName": "恩平市",
      "mergerName": "中国,广东省,江门市,恩平市",
      "areaLevel": "3"
    },
    {
      "id": "440800",
      "parentId": "440000",
      "areaName": "湛江市",
      "mergerName": "中国,广东省,湛江市",
      "areaLevel": "2"
    },
    {
      "id": "440802",
      "parentId": "440800",
      "areaName": "赤坎区",
      "mergerName": "中国,广东省,湛江市,赤坎区",
      "areaLevel": "3"
    },
    {
      "id": "440803",
      "parentId": "440800",
      "areaName": "霞山区",
      "mergerName": "中国,广东省,湛江市,霞山区",
      "areaLevel": "3"
    },
    {
      "id": "440804",
      "parentId": "440800",
      "areaName": "坡头区",
      "mergerName": "中国,广东省,湛江市,坡头区",
      "areaLevel": "3"
    },
    {
      "id": "440811",
      "parentId": "440800",
      "areaName": "麻章区",
      "mergerName": "中国,广东省,湛江市,麻章区",
      "areaLevel": "3"
    },
    {
      "id": "440823",
      "parentId": "440800",
      "areaName": "遂溪县",
      "mergerName": "中国,广东省,湛江市,遂溪县",
      "areaLevel": "3"
    },
    {
      "id": "440825",
      "parentId": "440800",
      "areaName": "徐闻县",
      "mergerName": "中国,广东省,湛江市,徐闻县",
      "areaLevel": "3"
    },
    {
      "id": "440881",
      "parentId": "440800",
      "areaName": "廉江市",
      "mergerName": "中国,广东省,湛江市,廉江市",
      "areaLevel": "3"
    },
    {
      "id": "440882",
      "parentId": "440800",
      "areaName": "雷州市",
      "mergerName": "中国,广东省,湛江市,雷州市",
      "areaLevel": "3"
    },
    {
      "id": "440883",
      "parentId": "440800",
      "areaName": "吴川市",
      "mergerName": "中国,广东省,湛江市,吴川市",
      "areaLevel": "3"
    },
    {
      "id": "440884",
      "parentId": "440800",
      "areaName": "经济开发区",
      "mergerName": "中国,广东省,湛江市,经济开发区",
      "areaLevel": "3"
    },
    {
      "id": "440900",
      "parentId": "440000",
      "areaName": "茂名市",
      "mergerName": "中国,广东省,茂名市",
      "areaLevel": "2"
    },
    {
      "id": "440902",
      "parentId": "440900",
      "areaName": "茂南区",
      "mergerName": "中国,广东省,茂名市,茂南区",
      "areaLevel": "3"
    },
    {
      "id": "440904",
      "parentId": "440900",
      "areaName": "电白区",
      "mergerName": "中国,广东省,茂名市,电白区",
      "areaLevel": "3"
    },
    {
      "id": "440981",
      "parentId": "440900",
      "areaName": "高州市",
      "mergerName": "中国,广东省,茂名市,高州市",
      "areaLevel": "3"
    },
    {
      "id": "440982",
      "parentId": "440900",
      "areaName": "化州市",
      "mergerName": "中国,广东省,茂名市,化州市",
      "areaLevel": "3"
    },
    {
      "id": "440983",
      "parentId": "440900",
      "areaName": "信宜市",
      "mergerName": "中国,广东省,茂名市,信宜市",
      "areaLevel": "3"
    },
    {
      "id": "441200",
      "parentId": "440000",
      "areaName": "肇庆市",
      "mergerName": "中国,广东省,肇庆市",
      "areaLevel": "2"
    },
    {
      "id": "441202",
      "parentId": "441200",
      "areaName": "端州区",
      "mergerName": "中国,广东省,肇庆市,端州区",
      "areaLevel": "3"
    },
    {
      "id": "441203",
      "parentId": "441200",
      "areaName": "鼎湖区",
      "mergerName": "中国,广东省,肇庆市,鼎湖区",
      "areaLevel": "3"
    },
    {
      "id": "441204",
      "parentId": "441200",
      "areaName": "高要区",
      "mergerName": "中国,广东省,肇庆市,高要区",
      "areaLevel": "3"
    },
    {
      "id": "441223",
      "parentId": "441200",
      "areaName": "广宁县",
      "mergerName": "中国,广东省,肇庆市,广宁县",
      "areaLevel": "3"
    },
    {
      "id": "441224",
      "parentId": "441200",
      "areaName": "怀集县",
      "mergerName": "中国,广东省,肇庆市,怀集县",
      "areaLevel": "3"
    },
    {
      "id": "441225",
      "parentId": "441200",
      "areaName": "封开县",
      "mergerName": "中国,广东省,肇庆市,封开县",
      "areaLevel": "3"
    },
    {
      "id": "441226",
      "parentId": "441200",
      "areaName": "德庆县",
      "mergerName": "中国,广东省,肇庆市,德庆县",
      "areaLevel": "3"
    },
    {
      "id": "441284",
      "parentId": "441200",
      "areaName": "四会市",
      "mergerName": "中国,广东省,肇庆市,四会市",
      "areaLevel": "3"
    },
    {
      "id": "441300",
      "parentId": "440000",
      "areaName": "惠州市",
      "mergerName": "中国,广东省,惠州市",
      "areaLevel": "2"
    },
    {
      "id": "441302",
      "parentId": "441300",
      "areaName": "惠城区",
      "mergerName": "中国,广东省,惠州市,惠城区",
      "areaLevel": "3"
    },
    {
      "id": "441303",
      "parentId": "441300",
      "areaName": "惠阳区",
      "mergerName": "中国,广东省,惠州市,惠阳区",
      "areaLevel": "3"
    },
    {
      "id": "441322",
      "parentId": "441300",
      "areaName": "博罗县",
      "mergerName": "中国,广东省,惠州市,博罗县",
      "areaLevel": "3"
    },
    {
      "id": "441323",
      "parentId": "441300",
      "areaName": "惠东县",
      "mergerName": "中国,广东省,惠州市,惠东县",
      "areaLevel": "3"
    },
    {
      "id": "441324",
      "parentId": "441300",
      "areaName": "龙门县",
      "mergerName": "中国,广东省,惠州市,龙门县",
      "areaLevel": "3"
    },
    {
      "id": "441325",
      "parentId": "441300",
      "areaName": "大亚湾区",
      "mergerName": "中国,广东省,惠州市,大亚湾区",
      "areaLevel": "3"
    },
    {
      "id": "441400",
      "parentId": "440000",
      "areaName": "梅州市",
      "mergerName": "中国,广东省,梅州市",
      "areaLevel": "2"
    },
    {
      "id": "441402",
      "parentId": "441400",
      "areaName": "梅江区",
      "mergerName": "中国,广东省,梅州市,梅江区",
      "areaLevel": "3"
    },
    {
      "id": "441403",
      "parentId": "441400",
      "areaName": "梅县区",
      "mergerName": "中国,广东省,梅州市,梅县区",
      "areaLevel": "3"
    },
    {
      "id": "441422",
      "parentId": "441400",
      "areaName": "大埔县",
      "mergerName": "中国,广东省,梅州市,大埔县",
      "areaLevel": "3"
    },
    {
      "id": "441423",
      "parentId": "441400",
      "areaName": "丰顺县",
      "mergerName": "中国,广东省,梅州市,丰顺县",
      "areaLevel": "3"
    },
    {
      "id": "441424",
      "parentId": "441400",
      "areaName": "五华县",
      "mergerName": "中国,广东省,梅州市,五华县",
      "areaLevel": "3"
    },
    {
      "id": "441426",
      "parentId": "441400",
      "areaName": "平远县",
      "mergerName": "中国,广东省,梅州市,平远县",
      "areaLevel": "3"
    },
    {
      "id": "441427",
      "parentId": "441400",
      "areaName": "蕉岭县",
      "mergerName": "中国,广东省,梅州市,蕉岭县",
      "areaLevel": "3"
    },
    {
      "id": "441481",
      "parentId": "441400",
      "areaName": "兴宁市",
      "mergerName": "中国,广东省,梅州市,兴宁市",
      "areaLevel": "3"
    },
    {
      "id": "441500",
      "parentId": "440000",
      "areaName": "汕尾市",
      "mergerName": "中国,广东省,汕尾市",
      "areaLevel": "2"
    },
    {
      "id": "441502",
      "parentId": "441500",
      "areaName": "城区",
      "mergerName": "中国,广东省,汕尾市,城区",
      "areaLevel": "3"
    },
    {
      "id": "441521",
      "parentId": "441500",
      "areaName": "海丰县",
      "mergerName": "中国,广东省,汕尾市,海丰县",
      "areaLevel": "3"
    },
    {
      "id": "441523",
      "parentId": "441500",
      "areaName": "陆河县",
      "mergerName": "中国,广东省,汕尾市,陆河县",
      "areaLevel": "3"
    },
    {
      "id": "441581",
      "parentId": "441500",
      "areaName": "陆丰市",
      "mergerName": "中国,广东省,汕尾市,陆丰市",
      "areaLevel": "3"
    },
    {
      "id": "441600",
      "parentId": "440000",
      "areaName": "河源市",
      "mergerName": "中国,广东省,河源市",
      "areaLevel": "2"
    },
    {
      "id": "441602",
      "parentId": "441600",
      "areaName": "源城区",
      "mergerName": "中国,广东省,河源市,源城区",
      "areaLevel": "3"
    },
    {
      "id": "441621",
      "parentId": "441600",
      "areaName": "紫金县",
      "mergerName": "中国,广东省,河源市,紫金县",
      "areaLevel": "3"
    },
    {
      "id": "441622",
      "parentId": "441600",
      "areaName": "龙川县",
      "mergerName": "中国,广东省,河源市,龙川县",
      "areaLevel": "3"
    },
    {
      "id": "441623",
      "parentId": "441600",
      "areaName": "连平县",
      "mergerName": "中国,广东省,河源市,连平县",
      "areaLevel": "3"
    },
    {
      "id": "441624",
      "parentId": "441600",
      "areaName": "和平县",
      "mergerName": "中国,广东省,河源市,和平县",
      "areaLevel": "3"
    },
    {
      "id": "441625",
      "parentId": "441600",
      "areaName": "东源县",
      "mergerName": "中国,广东省,河源市,东源县",
      "areaLevel": "3"
    },
    {
      "id": "441700",
      "parentId": "440000",
      "areaName": "阳江市",
      "mergerName": "中国,广东省,阳江市",
      "areaLevel": "2"
    },
    {
      "id": "441702",
      "parentId": "441700",
      "areaName": "江城区",
      "mergerName": "中国,广东省,阳江市,江城区",
      "areaLevel": "3"
    },
    {
      "id": "441704",
      "parentId": "441700",
      "areaName": "阳东区",
      "mergerName": "中国,广东省,阳江市,阳东区",
      "areaLevel": "3"
    },
    {
      "id": "441721",
      "parentId": "441700",
      "areaName": "阳西县",
      "mergerName": "中国,广东省,阳江市,阳西县",
      "areaLevel": "3"
    },
    {
      "id": "441781",
      "parentId": "441700",
      "areaName": "阳春市",
      "mergerName": "中国,广东省,阳江市,阳春市",
      "areaLevel": "3"
    },
    {
      "id": "441800",
      "parentId": "440000",
      "areaName": "清远市",
      "mergerName": "中国,广东省,清远市",
      "areaLevel": "2"
    },
    {
      "id": "441802",
      "parentId": "441800",
      "areaName": "清城区",
      "mergerName": "中国,广东省,清远市,清城区",
      "areaLevel": "3"
    },
    {
      "id": "441803",
      "parentId": "441800",
      "areaName": "清新区",
      "mergerName": "中国,广东省,清远市,清新区",
      "areaLevel": "3"
    },
    {
      "id": "441821",
      "parentId": "441800",
      "areaName": "佛冈县",
      "mergerName": "中国,广东省,清远市,佛冈县",
      "areaLevel": "3"
    },
    {
      "id": "441823",
      "parentId": "441800",
      "areaName": "阳山县",
      "mergerName": "中国,广东省,清远市,阳山县",
      "areaLevel": "3"
    },
    {
      "id": "441825",
      "parentId": "441800",
      "areaName": "连山壮族瑶族自治县",
      "mergerName": "中国,广东省,清远市,连山壮族瑶族自治县",
      "areaLevel": "3"
    },
    {
      "id": "441826",
      "parentId": "441800",
      "areaName": "连南瑶族自治县",
      "mergerName": "中国,广东省,清远市,连南瑶族自治县",
      "areaLevel": "3"
    },
    {
      "id": "441881",
      "parentId": "441800",
      "areaName": "英德市",
      "mergerName": "中国,广东省,清远市,英德市",
      "areaLevel": "3"
    },
    {
      "id": "441882",
      "parentId": "441800",
      "areaName": "连州市",
      "mergerName": "中国,广东省,清远市,连州市",
      "areaLevel": "3"
    },
    {
      "id": "441900",
      "parentId": "440000",
      "areaName": "东莞市",
      "mergerName": "中国,广东省,东莞市",
      "areaLevel": "2"
    },
    {
      "id": "441901",
      "parentId": "441900",
      "areaName": "莞城区",
      "mergerName": "中国,广东省,东莞市,莞城区",
      "areaLevel": "3"
    },
    {
      "id": "441902",
      "parentId": "441900",
      "areaName": "南城区",
      "mergerName": "中国,广东省,东莞市,南城区",
      "areaLevel": "3"
    },
    {
      "id": "441903",
      "parentId": "441900",
      "areaName": "东城区",
      "mergerName": "中国,广东省,东莞市,东城区",
      "areaLevel": "3"
    },
    {
      "id": "441904",
      "parentId": "441900",
      "areaName": "万江区",
      "mergerName": "中国,广东省,东莞市,万江区",
      "areaLevel": "3"
    },
    {
      "id": "441905",
      "parentId": "441900",
      "areaName": "石碣镇",
      "mergerName": "中国,广东省,东莞市,石碣镇",
      "areaLevel": "3"
    },
    {
      "id": "441906",
      "parentId": "441900",
      "areaName": "石龙镇",
      "mergerName": "中国,广东省,东莞市,石龙镇",
      "areaLevel": "3"
    },
    {
      "id": "441907",
      "parentId": "441900",
      "areaName": "茶山镇",
      "mergerName": "中国,广东省,东莞市,茶山镇",
      "areaLevel": "3"
    },
    {
      "id": "441908",
      "parentId": "441900",
      "areaName": "石排镇",
      "mergerName": "中国,广东省,东莞市,石排镇",
      "areaLevel": "3"
    },
    {
      "id": "441909",
      "parentId": "441900",
      "areaName": "企石镇",
      "mergerName": "中国,广东省,东莞市,企石镇",
      "areaLevel": "3"
    },
    {
      "id": "441910",
      "parentId": "441900",
      "areaName": "横沥镇",
      "mergerName": "中国,广东省,东莞市,横沥镇",
      "areaLevel": "3"
    },
    {
      "id": "441911",
      "parentId": "441900",
      "areaName": "桥头镇",
      "mergerName": "中国,广东省,东莞市,桥头镇",
      "areaLevel": "3"
    },
    {
      "id": "441912",
      "parentId": "441900",
      "areaName": "谢岗镇",
      "mergerName": "中国,广东省,东莞市,谢岗镇",
      "areaLevel": "3"
    },
    {
      "id": "441913",
      "parentId": "441900",
      "areaName": "东坑镇",
      "mergerName": "中国,广东省,东莞市,东坑镇",
      "areaLevel": "3"
    },
    {
      "id": "441914",
      "parentId": "441900",
      "areaName": "常平镇",
      "mergerName": "中国,广东省,东莞市,常平镇",
      "areaLevel": "3"
    },
    {
      "id": "441915",
      "parentId": "441900",
      "areaName": "寮步镇",
      "mergerName": "中国,广东省,东莞市,寮步镇",
      "areaLevel": "3"
    },
    {
      "id": "441916",
      "parentId": "441900",
      "areaName": "大朗镇",
      "mergerName": "中国,广东省,东莞市,大朗镇",
      "areaLevel": "3"
    },
    {
      "id": "441917",
      "parentId": "441900",
      "areaName": "麻涌镇",
      "mergerName": "中国,广东省,东莞市,麻涌镇",
      "areaLevel": "3"
    },
    {
      "id": "441918",
      "parentId": "441900",
      "areaName": "中堂镇",
      "mergerName": "中国,广东省,东莞市,中堂镇",
      "areaLevel": "3"
    },
    {
      "id": "441919",
      "parentId": "441900",
      "areaName": "高埗镇",
      "mergerName": "中国,广东省,东莞市,高埗镇",
      "areaLevel": "3"
    },
    {
      "id": "441920",
      "parentId": "441900",
      "areaName": "樟木头镇",
      "mergerName": "中国,广东省,东莞市,樟木头镇",
      "areaLevel": "3"
    },
    {
      "id": "441921",
      "parentId": "441900",
      "areaName": "大岭山镇",
      "mergerName": "中国,广东省,东莞市,大岭山镇",
      "areaLevel": "3"
    },
    {
      "id": "441922",
      "parentId": "441900",
      "areaName": "望牛墩镇",
      "mergerName": "中国,广东省,东莞市,望牛墩镇",
      "areaLevel": "3"
    },
    {
      "id": "441923",
      "parentId": "441900",
      "areaName": "黄江镇",
      "mergerName": "中国,广东省,东莞市,黄江镇",
      "areaLevel": "3"
    },
    {
      "id": "441924",
      "parentId": "441900",
      "areaName": "洪梅镇",
      "mergerName": "中国,广东省,东莞市,洪梅镇",
      "areaLevel": "3"
    },
    {
      "id": "441925",
      "parentId": "441900",
      "areaName": "清溪镇",
      "mergerName": "中国,广东省,东莞市,清溪镇",
      "areaLevel": "3"
    },
    {
      "id": "441926",
      "parentId": "441900",
      "areaName": "沙田镇",
      "mergerName": "中国,广东省,东莞市,沙田镇",
      "areaLevel": "3"
    },
    {
      "id": "441927",
      "parentId": "441900",
      "areaName": "道滘镇",
      "mergerName": "中国,广东省,东莞市,道滘镇",
      "areaLevel": "3"
    },
    {
      "id": "441928",
      "parentId": "441900",
      "areaName": "塘厦镇",
      "mergerName": "中国,广东省,东莞市,塘厦镇",
      "areaLevel": "3"
    },
    {
      "id": "441929",
      "parentId": "441900",
      "areaName": "虎门镇",
      "mergerName": "中国,广东省,东莞市,虎门镇",
      "areaLevel": "3"
    },
    {
      "id": "441930",
      "parentId": "441900",
      "areaName": "厚街镇",
      "mergerName": "中国,广东省,东莞市,厚街镇",
      "areaLevel": "3"
    },
    {
      "id": "441931",
      "parentId": "441900",
      "areaName": "凤岗镇",
      "mergerName": "中国,广东省,东莞市,凤岗镇",
      "areaLevel": "3"
    },
    {
      "id": "441932",
      "parentId": "441900",
      "areaName": "长安镇",
      "mergerName": "中国,广东省,东莞市,长安镇",
      "areaLevel": "3"
    },
    {
      "id": "441933",
      "parentId": "441900",
      "areaName": "松山湖高新区",
      "mergerName": "中国,广东省,东莞市,松山湖高新区",
      "areaLevel": "3"
    },
    {
      "id": "442000",
      "parentId": "440000",
      "areaName": "中山市",
      "mergerName": "中国,广东省,中山市",
      "areaLevel": "2"
    },
    {
      "id": "442001",
      "parentId": "442000",
      "areaName": "石岐区",
      "mergerName": "中国,广东省,中山市,石岐区",
      "areaLevel": "3"
    },
    {
      "id": "442002",
      "parentId": "442000",
      "areaName": "东区",
      "mergerName": "中国,广东省,中山市,东区",
      "areaLevel": "3"
    },
    {
      "id": "442003",
      "parentId": "442000",
      "areaName": "西区",
      "mergerName": "中国,广东省,中山市,西区",
      "areaLevel": "3"
    },
    {
      "id": "442004",
      "parentId": "442000",
      "areaName": "南区",
      "mergerName": "中国,广东省,中山市,南区",
      "areaLevel": "3"
    },
    {
      "id": "442005",
      "parentId": "442000",
      "areaName": "五桂山区",
      "mergerName": "中国,广东省,中山市,五桂山区",
      "areaLevel": "3"
    },
    {
      "id": "442006",
      "parentId": "442000",
      "areaName": "火炬开发区",
      "mergerName": "中国,广东省,中山市,火炬开发区",
      "areaLevel": "3"
    },
    {
      "id": "442007",
      "parentId": "442000",
      "areaName": "黄圃镇",
      "mergerName": "中国,广东省,中山市,黄圃镇",
      "areaLevel": "3"
    },
    {
      "id": "442008",
      "parentId": "442000",
      "areaName": "南头镇",
      "mergerName": "中国,广东省,中山市,南头镇",
      "areaLevel": "3"
    },
    {
      "id": "442009",
      "parentId": "442000",
      "areaName": "东凤镇",
      "mergerName": "中国,广东省,中山市,东凤镇",
      "areaLevel": "3"
    },
    {
      "id": "442010",
      "parentId": "442000",
      "areaName": "阜沙镇",
      "mergerName": "中国,广东省,中山市,阜沙镇",
      "areaLevel": "3"
    },
    {
      "id": "442011",
      "parentId": "442000",
      "areaName": "小榄镇",
      "mergerName": "中国,广东省,中山市,小榄镇",
      "areaLevel": "3"
    },
    {
      "id": "442012",
      "parentId": "442000",
      "areaName": "东升镇",
      "mergerName": "中国,广东省,中山市,东升镇",
      "areaLevel": "3"
    },
    {
      "id": "442013",
      "parentId": "442000",
      "areaName": "古镇镇",
      "mergerName": "中国,广东省,中山市,古镇镇",
      "areaLevel": "3"
    },
    {
      "id": "442014",
      "parentId": "442000",
      "areaName": "横栏镇",
      "mergerName": "中国,广东省,中山市,横栏镇",
      "areaLevel": "3"
    },
    {
      "id": "442015",
      "parentId": "442000",
      "areaName": "三角镇",
      "mergerName": "中国,广东省,中山市,三角镇",
      "areaLevel": "3"
    },
    {
      "id": "442016",
      "parentId": "442000",
      "areaName": "民众镇",
      "mergerName": "中国,广东省,中山市,民众镇",
      "areaLevel": "3"
    },
    {
      "id": "442017",
      "parentId": "442000",
      "areaName": "南朗镇",
      "mergerName": "中国,广东省,中山市,南朗镇",
      "areaLevel": "3"
    },
    {
      "id": "442018",
      "parentId": "442000",
      "areaName": "港口镇",
      "mergerName": "中国,广东省,中山市,港口镇",
      "areaLevel": "3"
    },
    {
      "id": "442019",
      "parentId": "442000",
      "areaName": "大涌镇",
      "mergerName": "中国,广东省,中山市,大涌镇",
      "areaLevel": "3"
    },
    {
      "id": "442020",
      "parentId": "442000",
      "areaName": "沙溪镇",
      "mergerName": "中国,广东省,中山市,沙溪镇",
      "areaLevel": "3"
    },
    {
      "id": "442021",
      "parentId": "442000",
      "areaName": "三乡镇",
      "mergerName": "中国,广东省,中山市,三乡镇",
      "areaLevel": "3"
    },
    {
      "id": "442022",
      "parentId": "442000",
      "areaName": "板芙镇",
      "mergerName": "中国,广东省,中山市,板芙镇",
      "areaLevel": "3"
    },
    {
      "id": "442023",
      "parentId": "442000",
      "areaName": "神湾镇",
      "mergerName": "中国,广东省,中山市,神湾镇",
      "areaLevel": "3"
    },
    {
      "id": "442024",
      "parentId": "442000",
      "areaName": "坦洲镇",
      "mergerName": "中国,广东省,中山市,坦洲镇",
      "areaLevel": "3"
    },
    {
      "id": "445100",
      "parentId": "440000",
      "areaName": "潮州市",
      "mergerName": "中国,广东省,潮州市",
      "areaLevel": "2"
    },
    {
      "id": "445102",
      "parentId": "445100",
      "areaName": "湘桥区",
      "mergerName": "中国,广东省,潮州市,湘桥区",
      "areaLevel": "3"
    },
    {
      "id": "445103",
      "parentId": "445100",
      "areaName": "潮安区",
      "mergerName": "中国,广东省,潮州市,潮安区",
      "areaLevel": "3"
    },
    {
      "id": "445122",
      "parentId": "445100",
      "areaName": "饶平县",
      "mergerName": "中国,广东省,潮州市,饶平县",
      "areaLevel": "3"
    },
    {
      "id": "445200",
      "parentId": "440000",
      "areaName": "揭阳市",
      "mergerName": "中国,广东省,揭阳市",
      "areaLevel": "2"
    },
    {
      "id": "445202",
      "parentId": "445200",
      "areaName": "榕城区",
      "mergerName": "中国,广东省,揭阳市,榕城区",
      "areaLevel": "3"
    },
    {
      "id": "445203",
      "parentId": "445200",
      "areaName": "揭东区",
      "mergerName": "中国,广东省,揭阳市,揭东区",
      "areaLevel": "3"
    },
    {
      "id": "445222",
      "parentId": "445200",
      "areaName": "揭西县",
      "mergerName": "中国,广东省,揭阳市,揭西县",
      "areaLevel": "3"
    },
    {
      "id": "445224",
      "parentId": "445200",
      "areaName": "惠来县",
      "mergerName": "中国,广东省,揭阳市,惠来县",
      "areaLevel": "3"
    },
    {
      "id": "445281",
      "parentId": "445200",
      "areaName": "普宁市",
      "mergerName": "中国,广东省,揭阳市,普宁市",
      "areaLevel": "3"
    },
    {
      "id": "445300",
      "parentId": "440000",
      "areaName": "云浮市",
      "mergerName": "中国,广东省,云浮市",
      "areaLevel": "2"
    },
    {
      "id": "445302",
      "parentId": "445300",
      "areaName": "云城区",
      "mergerName": "中国,广东省,云浮市,云城区",
      "areaLevel": "3"
    },
    {
      "id": "445303",
      "parentId": "445300",
      "areaName": "云安区",
      "mergerName": "中国,广东省,云浮市,云安区",
      "areaLevel": "3"
    },
    {
      "id": "445321",
      "parentId": "445300",
      "areaName": "新兴县",
      "mergerName": "中国,广东省,云浮市,新兴县",
      "areaLevel": "3"
    },
    {
      "id": "445322",
      "parentId": "445300",
      "areaName": "郁南县",
      "mergerName": "中国,广东省,云浮市,郁南县",
      "areaLevel": "3"
    },
    {
      "id": "445381",
      "parentId": "445300",
      "areaName": "罗定市",
      "mergerName": "中国,广东省,云浮市,罗定市",
      "areaLevel": "3"
    }
  ]
}